import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';

const AdminLayout = ({ user, onLogout }) => {
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <Sidebar user={user} onLogout={onLogout} />

      <div className="flex-1 flex flex-col">
        {/* Mobile Header */}
        <header className="md:hidden bg-white border-b shadow-sm sticky top-0 z-10 p-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-blue-600 rounded flex items-center justify-center">
              <span className="text-white font-bold">P</span>
            </div>
            <span className="font-bold text-gray-800">Pantera Admin</span>
          </div>
        </header>

        <main className="max-w-7xl w-full mx-auto px-4 py-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
